import React from "react";
import { Button } from "react-bootstrap";
import Img from "../assets/images/allJobs_banner.png";
import JobLogo from "../assets/images/job_logo.png";
import { imageUrl } from "../Config/apiUrl";
import "../assets/styles/contractCard.css";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
const ContractCard = ({ data, onClick, isCompany }) => {
  const user = useSelector((state) => state?.authReducer?.user);
  const history = useHistory();
  let imageSource = isCompany
    ? `${imageUrl}${data?.hired?.photo}`
    : `${imageUrl}${data?.companyId?.coverPhoto}`;

  let partyName = isCompany
    ? data?.hired?.userName
    : data?.companyId?.companyName;

  return (
    <div
      className="contract-card"
      onClick={() => {
        user?.UserId?.role == "company"
          ? history.push(`/craftman-profile?id=${data?.hired?._id}`)
          : history.push({
            pathname: `/job/${data?._id}`,
            state: data?._id,
          });
      }}
    >
      <div className="img-box">
        <img src={imageSource} className="img" />
        {!isCompany && (
          <span className="job-logo">
            <img src={`${imageUrl}${data?.companyId?.photo}`} />
          </span>
        )}
      </div>
      <div className="content">
        <h6 className="mb-4">{partyName}</h6>
        <h6 className="mb-4">{data?.title}</h6>
        {!isCompany && (
          <Button
            className="mt-2"
            onClick={(e) => {
              // event priority handler
              if (!e) {
                e = window.event;
              }
              e.stopPropagation();
              onClick();
            }}
          >
            View Contract
          </Button>
        )}
        {isCompany && (
          <Button
            className={`mt-2 ${
              data?.status == "offered" && "gray-button-light"
            }`}
            disabled={data?.status == "offered"}
            onClick={(e) => {
              // event priority handler
              if (!e) {
                e = window.event;
              }
              e.stopPropagation();
              data?.status !== "offered" && onClick();
            }}
          >
            {data?.status == "offered" ? "In Process" : "View Contract"}
          </Button>
        )}
      </div>
    </div>
  );
};
export default ContractCard;
